import React from "react";
import { getCalendarDay } from "../../calendar/utils";
import { TweakProvider } from "../../utils/TweakProvider";
import { Compline } from "../pray/compline/Compline";

export const ComplineToday: React.FC<{}> = () => {
    const dateTime = new Date();
    if (dateTime.getHours() < 3) {
        dateTime.setDate(dateTime.getDate() - 1);
    }

    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();

    const day = getCalendarDay(year, month, date, true);

    return (
        <TweakProvider initialState={{}}>
            <Compline day={day} />
        </TweakProvider>
    );
};
